import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {DiffOperatorParameters} from "#template/nodes/geometry-graph/attribute/diff-operator/geometry-diff-operator-node"
import {GeometryDiffOperatorNode, diffOperatorParametersSchema} from "#template/nodes/geometry-graph/attribute/diff-operator/geometry-diff-operator-node"

const definition: TemplateNodeDefinition<DiffOperatorParameters> = {
    nodeClass: "CurveGeometryDiffOperator",
    validation: {
        parameters: diffOperatorParametersSchema,
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryDiffOperator extends GeometryDiffOperatorNode implements CurveGeometryAttributeLikeNode {
    get [curveGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
